import { create } from 'zustand'
import type { FooterStore, FooterConfig } from '@/types'

const initialFooterConfig: FooterConfig = {
  step: null,
  totalSteps: null,
  button: null,
  showLogo: false,
  disabled: false,
}

export const useFooterStore = create<FooterStore>((set) => ({
  footerConfig: initialFooterConfig,

  // Vervangt de config, niet mergen: schermen roepen setFooterConfig({}) aan bij
  // unmount om de footer te wissen. Ontbrekende velden vallen terug op de
  // begintoestand, zodat FooterConfig ook echt compleet is.
  setFooterConfig: (config: Partial<FooterConfig>) =>
    set({ footerConfig: { ...initialFooterConfig, ...config } }),

  reset: () => set({ footerConfig: initialFooterConfig }),
}))
